// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9ee1e386\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/postcss-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SaveForm.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("31f16301", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-9ee1e386","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/client/components/SaveForm.vue
// module id = 581
// module chunks = 1